export default "__VITE_ASSET__45ZwHePP__"